import * as React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { getAuthorizationToken } from 'mz-sdk/client'

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      getAuthorizationToken() ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: '/login',
            state: { from: props.location },
          }}
        />
      )
    }
  />
)

export default PrivateRoute
